export const mailing = [
  {
    path: '/mailing',
    component: () => import(/* webpackChunkName: "mailing" */ '@/views/mailing/Mailing'),
    children: [
      {
        path: 'create',
        component: () => import(/* webpackChunkName: "mailing" */ '@/views/mailing/components/MailingEditBody'),
      },
      {
        path: ':id/edit',
        component: () => import(/* webpackChunkName: "mailing" */ '@/views/mailing/components/MailingEditBody'),
      },
      {
        path: ':id/recipients',
        component: () => import(/* webpackChunkName: "mailing" */ '@/views/mailing/components/MailingRecipientsBody'),
      },
      {
        path: ':id/template',
        component: () => import(/* webpackChunkName: "mailing" */ '@/views/mailing/components/MailingTemplateBody'),
      },
      {
        path: ':id/attachments',
        component: () => import(/* webpackChunkName: "mailing" */ '@/views/mailing/components/MailingAttachmentsBody'),
      },
      {
        path: ':id/delivery',
        component: () => import(/* webpackChunkName: "mailing" */ '@/views/mailing/components/MailingDeliveryBody'),
      },
      {
        path: ':id/tracking',
        component: () => import(/* webpackChunkName: "mailing" */ '@/views/mailing/components/MailingMessagesBody'),
      },
      {
        path: ':id/tracking/:message_id',
        component: () => import(/* webpackChunkName: "mailing" */ '@/views/mailing/components/MailingMessageBody'),
      },
    ]
  },
]
